import React from "react";

import PageHeader from "../../../../molecules/PatientDetailsV2/PageHeader/PageHeader";

import RedirectComponent from "../../../../atoms/RedirectComponent/RedirectComponent";

const SleepTaskPage: React.FC<any> = () => {
  return (
    <div>
      <PageHeader title="Sleep" />
      <RedirectComponent moduleName="sleep" />
    </div>
  );
};

export default SleepTaskPage;
